const middleware = {}

middleware['authenticated/check-mobile-verified'] = require('../../../app/middleware/authenticated/check-mobile-verified.js')
middleware['authenticated/check-mobile-verified'] = middleware['authenticated/check-mobile-verified'].default || middleware['authenticated/check-mobile-verified']

middleware['authenticated/redirect-authenticated'] = require('../../../app/middleware/authenticated/redirect-authenticated.js')
middleware['authenticated/redirect-authenticated'] = middleware['authenticated/redirect-authenticated'].default || middleware['authenticated/redirect-authenticated']

middleware['authenticated/redirect-verified'] = require('../../../app/middleware/authenticated/redirect-verified.js')
middleware['authenticated/redirect-verified'] = middleware['authenticated/redirect-verified'].default || middleware['authenticated/redirect-verified']

middleware['check-for-update'] = require('../../../app/middleware/check-for-update.js')
middleware['check-for-update'] = middleware['check-for-update'].default || middleware['check-for-update']

middleware['dev-only'] = require('../../../app/middleware/dev-only.js')
middleware['dev-only'] = middleware['dev-only'].default || middleware['dev-only']

middleware['user-activity'] = require('../../../app/middleware/user-activity.js')
middleware['user-activity'] = middleware['user-activity'].default || middleware['user-activity']

export default middleware
